package com.essntl.features.price.data.supabase.proposalserviceprice

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [ProposalServicePriceSupabaseDataSource::class])
internal class ProposalServicePriceSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<ProposalServicePriceDto> {
    override val tableName: String = "proposal_service_price"
}